import React                      from 'react';
import { Observe }                from 'rewire-core';
import Typography                 from '@material-ui/core/Typography';
import timeOffBalancesDialogModel from '../schedule/TimeOffBalancesDialogModel';
import RowSelectionGrid           from '../ui/RowSelectionGrid';
import { Theme, makeStyles }      from '../utility/styles';

const styles = (theme: Theme) => ({
  button: {
    minWidth: '100px',
    minHeight: '0px',
    padding: '5px',
  },
  header: {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
  },
  icon: {
    marginRight: '6px',
    color: theme.palette.success.main,
  },
  divider: {
    marginTop: '12px',
  },
  grid: {
    marginTop: '6px',
    maxHeight: '345px',
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
  },
  title: {
    marginTop: '5px',
  },
  noResults: {
    fontStyle: 'italic',
  }
});

const useStyles = makeStyles(styles);

const TimeOffRequestHistoryView = (_props: Record<string, unknown>): JSX.Element | null => {
  const classes       = useStyles();
  const gridFontSizes = {
    header:     '0.75em',
    body:       '0.75em',
    groupRow:   '1em',
    toggleMenu: '0.8em',
  };

  return <Observe render={() => {
    const timeOffType   = timeOffBalancesDialogModel.selectedTimeOffType?.name;
    const noTimeOffType = !timeOffType ? 'No time off type selected' : ' ';
    const noUpcoming    = timeOffType && timeOffBalancesDialogModel.upcomingTimeOffRequestsGrid.rows.length === 0 ? `No upcoming ${timeOffType} requests`: '';
    const noPast        = timeOffType && timeOffBalancesDialogModel.pastTimeOffRequestsGrid.rows.length     === 0 ? `No past ${timeOffType} requests`    : '';

    return (
      <div>
        {noTimeOffType && <Typography variant='caption' className={classes.noResults}>{noTimeOffType}</Typography>}

        <Typography className={classes.title}>Upcoming Time Off</Typography>
        <RowSelectionGrid grid={timeOffBalancesDialogModel.upcomingTimeOffRequestsGrid} className={classes.grid} gridFontSizes={gridFontSizes}/>
        {noUpcoming && <Typography variant='caption' className={classes.noResults}>{noUpcoming}</Typography>}

        <Typography className={classes.title}>Past Time Off</Typography>
        <RowSelectionGrid grid={timeOffBalancesDialogModel.pastTimeOffRequestsGrid} className={classes.grid} gridFontSizes={gridFontSizes}/>
        {noPast && <Typography variant='caption' className={classes.noResults}>{noPast}</Typography>}

        {/* <MessagesView className={classes.divider} title='Messages' messages={timeOffBalancesDialogModel.messages} /> */}
      </div>
    );
   }} />;
};

export default TimeOffRequestHistoryView;
